import { LocalStorageKeys } from '@/types';
export var PendingDeepLinkStorageKey = 'pendingDeepLink';
export var getSessionStorage = function () {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        return window.sessionStorage;
    }
    catch (e) {
        return null;
    }
};
export var savePendingNavigation = function (value) {
    var storage = getSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(LocalStorageKeys.RedirectUrl);
    storage.setItem(PendingDeepLinkStorageKey, value);
};
export var savePostLoginNavigation = function (value) {
    var storage = getSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(PendingDeepLinkStorageKey);
    storage.setItem(LocalStorageKeys.RedirectUrl, value);
};
export var discardPendingNavigation = function () {
    var _a;
    (_a = getSessionStorage()) === null || _a === void 0 ? void 0 : _a.removeItem(PendingDeepLinkStorageKey);
};
export var discardPostLoginNavigation = function () {
    var _a;
    (_a = getSessionStorage()) === null || _a === void 0 ? void 0 : _a.removeItem(LocalStorageKeys.RedirectUrl);
};
export var discardNavigation = function () {
    var storage = getSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(PendingDeepLinkStorageKey);
    storage.removeItem(LocalStorageKeys.RedirectUrl);
};
